<template>
    <div id="help-settings">
        <div class="help-header">
            <div class="back">
                <router-link to="/home">
                    <font-awesome-icon icon="home" class="back-icon" />
                </router-link>
            </div>
        </div>
        <h2 class="title">À propos</h2>
        <LoadingDots v-if="isLoading" />

        <div class="help-body" v-if="!isLoading">
            <div class="help-section">
                <div class="section--para">
                    <img class="help-image" src="@/assets/logo_nb.png" />
                </div>

                <div class="section--para version">
                    {{ settings.app_name }} version {{ settings.app_build }} ({{
                        settings.app_release_date
                    }})
                </div>

                <div class="section--para dates">
                    <ul>
                        <li>
                            Date de mise à jour des nodes à valider :
                            {{ settings.osm_diff_nodes_date }} (GMT)
                        </li>
                        <li>
                            Date de mise à jour des ways à valider :
                            {{ settings.osm_diff_ways_date }} (GMT)
                        </li>
                        <li>
                            Date de mise à jour des relations à valider :
                            {{ settings.osm_diff_relations_date }} (GMT)
                        </li>
                    </ul>
                </div>

                <div class="section--para about">
                    <a class="link" href="https://www.lebontag.fr/" target="_blank">{{
                        settings.app_name
                    }}</a>
                    est un outil de validation de données OSM (OpenStreetMap) développé par
                    <a class="link" href="https://www.geonov.fr/" target="_blank">Geonov</a>.
                </div>

                <div class="section--para about">
                    Son développement a été financé par
                    <a class="link" href="https://www.montpellier3m.fr/" target="_blank"
                        >Montpellier Méditerranée Métropole</a
                    >, le
                    <a class="link" href="https://www.sdis34.fr/" target="_blank">SDIS 34</a> et
                    <a class="link" href="https://www.brest.fr/" target="_blank">Brest Métropole</a
                    >.
                </div>

                <div class="section--para">
                    <img class="help-logo" src="@/assets/logo-geonov.png" alt="Geonov" />
                    <img
                        class="help-logo"
                        src="@/assets/logo-mmm.png"
                        alt="Montpellier Méditerranée Métropole"
                    />
                    <img class="help-logo" src="@/assets/logo-sdis34.png" alt="SDIS 34" />
                    <img class="help-logo" src="@/assets/logo-brest.png" alt="Brest Métropole" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingDots from '@/components/LoadingDots';

export default {
    data() {
        return {
            isLoading: true,
            settings: {
                app_build: null,
                app_release_date: null,
                app_name: null,
                osm_diff_nodes_date: null,
                osm_diff_ways_date: null,
                osm_diff_relations_date: null,
            },
            loaded_settings: [],
        };
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.$http
                .get('/api/setting')
                .then(
                    (response) => {
                        const settings = response.body;
                        this.loaded_settings = settings;
                        settings.forEach((s) => (this.settings[s.name] = s.value));
                    },
                    (response) => {
                        // error callback
                        console.log(JSON.stringify(response));
                    },
                )
                .finally(() => (this.isLoading = false));
        },
    },
    components: {
        LoadingDots,
    },
};
</script>

<style lang="scss">
.link {
    text-decoration: none;
    color: #6c3e91;
    font-weight: bold;
}
.help-logo {
    margin-left: 10px;
    margin-right: 10px;
    vertical-align: middle;
    max-height: 60px;
}
.version {
    font-weight: bold;
    font-size: 1.3em;
    padding-bottom: 15px;
}
.dates {
    font-style: italic;
    font-size: 1.3em;
    padding-bottom: 15px;
}
.about {
    font-size: 1.2em;
    padding-bottom: 10px;
}
.help-image {
    display: block;
    height: auto;
    width: 100%;
    max-width: 300px;
    max-height: 300px;
    margin-bottom: 35px;
}
.help-header {
    height: 50px;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;

    .back {
        box-sizing: border-box;
        width: 50px;
        opacity: 0.5;
        box-shadow: 2px 0 4px 2px rgba(212, 216, 221, 0.43);
        display: flex;
        align-items: center;
        justify-content: center;

        .back-icon {
            width: 25px;
            height: 25px;
            color: #8e919b;
        }
    }
}
.help-body {
    margin: 25px 30px;
    padding: 20px 0;
    border: 1px solid #9ca5b0;
    border-radius: 5px;
    border-top: 5px solid #6c3e91;
    background-color: #ffffff;

    .help-section {
        h3.section--title {
            margin: 5px 35px 20px;
            padding-bottom: 5px;
            font-size: 2em;
            font-weight: 600;
            text-transform: uppercase;
            border-bottom: 3px solid black;
        }
        div.section--para {
            margin: 5px 35px 20px;
        }
    }

    .mt-5 {
        margin-top: 5em;
    }
}
</style>
